import styled from "styled-components";
type ImageProps = {
  $img: string;
};

export const Container = styled.div`
  margin: 0 auto;
  width: 1300px;
  margin-bottom: 40px;
  @media (max-width: 430px) {
    width: 393px;
  }
`;
export const TagsContainer = styled.div`
  display: flex;
  gap: 6px;
  justify-content: center;
`;

export const Tags = styled.div`
  font-family: Avenir Next;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  background-color: #bfdcf5;
  border: 1px solid #bfdcf5;
  border-radius: 20px;
  padding: 1px 10px;
  margin-top: 32px;
  margin-bottom: 40px;
`;
export const CreatedAt = styled.div`
  margin-top: 26px;
  margin-bottom: 8px;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  color: #a7a7a7;
`;
export const ContentContainer = styled.div`
  width: 1300px;
  text-align: center;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  @media (max-width: 430px) {
    width: 393px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export const P = styled.div`
  text-align: left;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  @media (max-width: 430px) {
    width: 393px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export const Img = styled.div<ImageProps>`
  width: 425px;
  height: 200px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;
`;

export const Tags2 = styled.div`
  margin: 0 auto;
  display: flex;
  gap: 12px;
  margin-bottom: 44px;
  margin-top: 20px;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 430px) {
    flex-wrap: nowrap;
    justify-content: start;
    margin-left: 20px;
    overflow-x: auto;
    overflow-y: hidden;
    margin-right: 10px;
    height: 30px;
  }
`;

export const H1 = styled.h1`
  font-family: Cormorant Infant;
  font-size: 75px;
  font-weight: 500;
  text-align: center;
  @media (max-width: 430px) {
    width: 383px;
    font-size: 55px;
  }
`;
